import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  return (
    <div ref={ref} className="relative w-full max-w-md mx-auto">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-3 px-4 py-3 bg-background-50 border border-background-300 rounded-lg text-sm text-foreground-800 hover:border-primary-400 transition-colors cursor-pointer"
      >
        <span className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex items-center justify-center w-5 h-5 text-primary-600">
            <i className="ri-grid-line text-base" />
          </span>
          {t('categories.dropdownLabel')}
        </span>
        <i className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute z-30 mt-2 w-full bg-background-50 border border-background-200 rounded-lg overflow-hidden max-h-80 overflow-y-auto">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.link}
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center justify-between px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-100/70 transition-colors cursor-pointer whitespace-nowrap"
            >
              <span>{t(`cat.${cat.id}`)}</span>
              <span className="flex items-center justify-center w-4 h-4 text-foreground-400">
                <i className="ri-external-link-line text-sm" />
              </span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}